<template>
  <div class="recent-donations flex flex-grow flex-col align-center">
    <div
      class="text-sm weight-600 title mb-3 text-center"
      data-test="title"
    >
      RECENT DONATIONS
    </div>
    <div
      v-if="donorStore.donations.length === 0"
      class="no-donations text-center"
      data-test="no-donations"
    >
      <p class="text-xl font-semibold mt-2 mb-3 mx-3">You haven’t made any donations yet.</p>
      <p class="text-base">Find the causes that matter most to you on our organization search page!</p>

      <div class="flex flex-col pt-4 pb-6 self-center items-center w-full">
        <Button
          class="p-button-outlined"
          :style="{ color: '#000' }"
          @click="redirectToCMS"
          data-test="browse-organizations-button"
        >
          Browse Organizations
        </Button>
      </div>
    </div>
    <div v-else>
      <div
        v-for="(donation, index) in donorStore.donations.slice(0, 5)"
        :key="`donation_${index}`"
        class="recent-donation-tile bg-white rounded-lg my-2 shadow-md"
        data-test="donation-tile"
      >
        <div class="donations-top p-3 flex flex-grow flex-col">
          <div class="flex flex-grow justify-between">
            <div
              class="donation-date text-xs font-light"
              data-test="donation-date"
            >
              {{ filters.formatDate(donation.enteredDate, 'long') }}
            </div>
            <div class="options -mt-3">
              <ActionPicker
                class="w-5 whitespace-nowrap"
                ref="app"
                :actions="menuStr"
                content-full-width
                @resendReceipt="donorStore.getSingleReceipt(donation.transactions_id)"
                data-test="action-picker"
              >
                <template #trigger>
                  <Button
                    type="button"
                    icon="pi pi-ellipsis-h"
                    class="p-button-secondary p-button-text p-button-sm action-button"
                    style="width: 10px"
                    data-test="action-button"
                  >
                    &hellip;
                  </Button>
                </template>
              </ActionPicker>
            </div>
          </div>
          <div
            class="donation-amount text-lg font-semibold"
            data-test="donation-amount"
          >
            {{ filters.formatMoney(donation.amount) }}
          </div>
          <div
            class="donation-cause text-sm font-normal me-4"
            data-test="donation-cause"
          >
            {{ donation.organization.organizationName }}
          </div>
        </div>
      </div>
      <div class="view-donations pt-4 pb-6 self-center">
        <Button
          class="w-full"
          @click="router.push('/donationHistory')"
          data-test="view-all-donations-button"
        >
          View All Donations
        </Button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useDonorStore } from '@/stores/DonorStore.js';
import filters from '@/helpers/filters';
import { useRouter } from 'vue-router';
import getContrastYIQ from '@/helpers/getContrastYIQ';
import ActionPicker from '@/components/ActionPicker.vue';

const donorStore = useDonorStore();
const mainColor = donorStore.mainColor;
const router = useRouter();

const menuItems = [
  {
    text: 'Resend Receipt',
    emit: 'resend-receipt',
    disabled: false,
    disabled_text: null,
    type: 'default',
  },
];

const menuStr = JSON.stringify(menuItems);

const redirectToCMS = () => {
  window.location.href = donorStore.domain.replace(/\/$/, '') + '/organizations';
};
</script>
